import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import type { Log } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Log>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'by',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'activities.table.by',
            }),
        enableSorting: false,
    },
    {
        accessorKey: 'description',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'activities.table.description',
            }),
        enableSorting: false,
    },
    {
        accessorKey: 'action',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'activities.table.action',
            }),
        enableSorting: false,
    },
    {
        accessorKey: 'for',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'activities.table.for',
            }),
        enableSorting: false,
    },
    {
        accessorKey: 'content',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'activities.table.content',
            }),
        cell: ({ row }) => {
            if (!row.original.content) return '';

            const json = JSON.parse(row.original.content.replaceAll(/&quot;/g, '"'));
            const formattedContent = Object.entries(json)
                .filter(([_, value]) => typeof value !== 'object')
                .map(([key, value]) => `<b>${key}:</b> ${value}`)
                .join('<br>');

            return h('div', {
                innerHTML: formattedContent,
                class: 'whitespace-pre-wrap',
            });
        },
        enableSorting: false,
    },
    {
        accessorKey: 'created_column',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'activities.table.created_column',
            }),
        enableSorting: false,
    },
];
